import React, { useState } from 'react'
import { Alert, Container } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { sanitize } from '../../formatters/Sanitize'

function SampleMessage(props: { messageId: string }) {
  const key = `sampleMessage.messageId.${props.messageId}`
  const { t, i18n } = useTranslation()
  const [show, setShow] = useState(i18n.exists(key))
  const text = t(key)
  return <>
    {show && <Container className="px-0"><Alert variant="info" onClose={() => setShow(false)} dismissible><div dangerouslySetInnerHTML={{ __html: sanitize(text) }} /></Alert></Container>}
  </>
}

export default SampleMessage
